import { Card, Divider } from 'antd'
import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { $t } from '~/i18n.js'

import { connect } from 'react-redux'
import { BreadcrumbHeader } from '~/components/layout/breadcrumbHeader.jsx'
import { MainLayout } from '~/components/layout/layout.jsx'
import { api } from '~/lib/api.js'
import { updateIfNeeded } from '~/lib/helpers.js'
import { parseMinutesLong, toLocaleDate } from '~/lib/localize.js'
import { flightsActions } from '~/redux/actions.js'
import { ExportFlightsToCSV } from "./exportFlightsToCSV.jsx";
import { HelpLine } from '~/components/help/helpLine.jsx'

const RenderCard = ({ title, total }) => {
  if (!total || !total.starts) return null;
  const showDays = total.days && total.days.length > 1;
  return (
    <Card style={{ marginTop: 24 }} size="small" title={<p className="bold">{title}</p>}>
      {showDays && total.days.map((day, i) => (
        <p key={i}>
          {day.type_dag}{day.titel ? ` – ${day.titel}` : ''}:{' '}
          {$t("${count} starts", { count: day.starts })}, {parseMinutesLong(day.minutes)}
        </p>
      ))}
      {showDays && <Divider style={{ margin: 6 }} />}
      <p>
        <span className="bold">{$t("Totaal")}:</span>{' '}
        {$t("${count} starts", { count: total.starts })}, {parseMinutesLong(total.minutes)}
      </p>
    </Card>
  );
};

const DagtotaalComponent = ({ history, match, flights, getBaseData, persist }) => {
  const [loading, setLoading] = useState(false);
  const [total, setTotal] = useState(null);
  const [allFlights, setFlights] = useState([]);
  const [message, setMessage] = useState(null);

  useEffect(() => {
    updateIfNeeded(flights.lastUpdatedBaseData, getBaseData, null, 3600000);
  }, [flights.lastUpdatedBaseData, getBaseData]);

  useEffect(() => {
    setLoading(true);
    api.post("flights/day_total.json", { dag_id: match.params.id }).then((res) => {
      if (res) {
        if (res.message) {
          setMessage(res.message);
        } else {
          setFlights(res.flights || []);

          if (res.total && Array.isArray(res.total)) {
            const totals = res.total.reduce((all, row) => {
              all.datum = all.datum || row.datum;
              all.starts += row.starts;
              all.minutes += row.minutes;

              // overall per-day subtotal (for the "Dag totaal" card)
              const existingDay = all.days.find(d => d.dag_id === row.dag_id);
              if (existingDay) {
                existingDay.starts += row.starts;
                existingDay.minutes += row.minutes;
              } else {
                all.days.push({ dag_id: row.dag_id, type_dag: row.type_dag, titel: row.titel, starts: row.starts, minutes: row.minutes });
              }

              // per aircraft
              if (!all[row.registratie]) {
                all[row.registratie] = { starts: 0, minutes: 0, days: [] };
                all.kisten.push(row.registratie);
              }
              all[row.registratie].starts += row.starts;
              all[row.registratie].minutes += row.minutes;
              all[row.registratie].days.push({ dag_id: row.dag_id, type_dag: row.type_dag, titel: row.titel, starts: row.starts, minutes: row.minutes });

              return all;
            }, { datum: null, starts: 0, minutes: 0, kisten: [], days: [] });

            setTotal(totals);
          }
        }
        setLoading(false);
      }
    });
  }, [match.params.id]);

  return (
    <MainLayout history={history} isLoading={loading || flights.isPending || !flights.lastUpdatedBaseData}>
      <BreadcrumbHeader
        breadcrumbs={[
          <Link to="/start" className="title" key="1">{$t("Startadministratie")}</Link>,
          total && total.datum ? toLocaleDate(new Date(total.datum)) : "",
        ]}
        buttons={[
          persist.profile.ziet_staff && <ExportFlightsToCSV flights={allFlights} date={total?.datum} />,
        ]}
      />

      {message && <p className="bold">{message}</p>}

      {!message && (
        <>
          <p className='title spacer'>{$t("Dagtotalen")}</p>

          <HelpLine>
            {$t("Let op: deze totalen zijn gebaseerd op de geregistreerde vluchten. Controleer of alle vluchten correct zijn geregistreerd voordat je de logboeken invult.")}
          </HelpLine>

          <RenderCard title={$t("Dag totaal")} total={total} />

          {total?.kisten?.map((registratie, key) => {
            const kist = flights.kisten?.find(k => k.registratie === registratie);
            const totalK = total[registratie];
            if (!totalK || totalK.starts === 0) return null;
            const kistTitle = kist
              ? `${kist.callsign ? kist.callsign + ': ' : ''}${kist.registratie}${kist.type ? ' (' + kist.type + ')' : ''}`
              : registratie;
            return <RenderCard key={key} title={kistTitle} total={totalK} />;
          })}
        </>
      )}
    </MainLayout>
  );
};

const mapStateToProps = (state) => ({
  flights: state.flights,
  persist: state.persist,
});

const mapDispatchToProps = (dispatch) => ({
  getBaseData: (d) => dispatch(flightsActions.getBaseData(d)),
});

export const DagtotaalPagina = connect(mapStateToProps, mapDispatchToProps)(DagtotaalComponent)
